<template>
  <div v-if="hasFields">
    <vs-col style="padding: 5px">
      <vs-row>Fields configured:</vs-row>
    </vs-col>
    <Field
      v-for="(field, index) in configuredFields"
      :key="index"
      :fieldInitState="field"
      @configuredFieldUpdated="params => updateConfiguredField(params)"
    />
  </div>
</template>

<script>
import Field from './Field'
import { mapActions } from 'vuex';

export default {
  name: "ConfiguredCustomFields",
  components: {
    Field
  },
  computed: {
    configuredFields () {
      let fields = [...this.$store.state.customFields.fields];
      return fields.map((f) => ({ ...f, isNew: false }));
    },
    hasFields () {
      return this.configuredFields.length > 0 ? true : false
    }
  },
  methods : {
    ...mapActions('customFields', ['updateConfiguredField'])
  }
};
</script>